var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSidebarLockIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 16,
  fill: "none",
  viewBox: "0 0 14 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7.001,
  cy: 10.5,
  r: 1.667,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.5,
  d: "M.75 9.25c0-1.571 0-2.357.488-2.845s1.274-.488 2.845-.488h5.834c1.571 0 2.357 0 2.845.488s.488 1.274.488 2.845v.833c0 2.357 0 3.536-.732 4.268s-1.911.732-4.268.732h-2.5c-2.357 0-3.536 0-4.268-.732S.75 12.441.75 10.083z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M10.75 5.917v-1.25A3.75 3.75 0 0 0 7 .917v0a3.75 3.75 0 0 0-3.75 3.75v1.25"
})));
export { SvgSidebarLockIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/sidebarLockIcon.svg";